import React, { useEffect, useState } from "react";
import CorrelationWorker from "../../../../../custom-lib/correlation_worker.js";
import { Icon, IconClose } from "../../../base/icons";
import WebWorker from "../../../../../custom-lib/workerSetup";

// css
import "./white-board.css";
import { Constant } from "../../../webjam/constant/index.js";
import { getBaseConfig } from "../../Utils.js";

const AudioWhiteboard2 = ({ socket, Sessions, closeTool }) => {
    // hide buttons and cross buttons
    const [isDisable, setIsDisable] = useState(false);

    const { openByUser, SessionId } = Sessions;

    // getting the web worker output here
    const interpret_correlation_result = event => {
        console.log("open", openByUser, SessionId);

        // student can able to send to techer
        socket.emit("audio2", {
            room: window.location.href,
            openTool: "audio2"
        });

        // emit data for newly opened user
        socket.emit("openTools_fromtool", {
            openTool: "audio2",
            SessionId: Sessions.openByUser,
            location: window.location.href
        });
    };

    // added web workers for new thread
    const correlation_worker = new WebWorker(CorrelationWorker);

    // message Event
    correlation_worker.addEventListener(
        "message",
        interpret_correlation_result
    );

    useEffect(() => {

        if (SessionId === openByUser) {
            setIsDisable(true);
            socket.emit("openTools_fromtool", {
                openTool: "audio2",
                SessionId: Sessions.openByUser,
                location: window.location.href
            });
        } else {
            //setIsDisable(true);
            socket.on("audio2_return", function (data) {
                debugger;
                const { location } = data;
                if (location === window.location.href) {
                }
            });
        }

        return function cleanup() {
            socket.off("audio2_return");
        };
    }, [openByUser]);

    return (
        <div className="whiteboardpage">
            <div className="close-side-bar" onClick={closeTool}>
                <Icon src={IconClose} />
            </div>
            <h1 id="note-name"> Audio-2 </h1>
            <hidden id="hdbNotes" />
            <iframe
                className="whiteboardiframe"
                // src= {Constant.App.whiteBoardUrl + "/s/audiotwoz-Untitled-Space"}
                src={getBaseConfig("whiteBoardUrl") + "/s/audiotwoz-Untitled-Space"}
                name="iframe_whiteboard"
                title="Whiteboard"
            ></iframe>
        </div>
    );
};

export default AudioWhiteboard2;
